import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { guideTokens } from '../theme/guideTokens';

interface GuideLightboxProps {
  open: boolean;
  src: string;
  alt: string;
  caption?: string;
  onClose: () => void;
}

export const GuideLightbox: React.FC<GuideLightboxProps> = ({
  open,
  src,
  alt,
  caption,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: (t) => (t.palette.mode === 'dark' ? '#0a0a0a' : '#111'),
          borderRadius: 2,
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ position: 'relative', p: { xs: 1, sm: 2 } }}>
        <IconButton
          onClick={onClose}
          aria-label="Close image"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            color: '#fff',
            bgcolor: 'rgba(0,0,0,0.45)',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.65)' },
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
            maxHeight: '80vh',
            objectFit: 'contain',
            borderRadius: 1,
          }}
        />
        {caption && (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 1.5,
              color: 'rgba(255,255,255,0.75)',
              fontFamily: guideTokens.fontBody,
              px: 0.5,
            }}
          >
            {caption}
          </Typography>
        )}
      </Box>
    </Dialog>
  );
};
